An array of certifications and licenses the candidate holds.

This field is redacted and an empty list is returned when a candidate or job application is deleted.
